import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class SpinnerService {

  public isLoading = new BehaviorSubject<boolean>(false);

  private _count: number = 0;
  get count(): number {
    return this._count;
  }

  get isBusy(): boolean {
    return this.count > 0;
  }

  public fullStop(){
    // console.trace("full stop");
    this._count = 0;
    this.isLoading.next(this.isBusy);
  }

  public activate() {
    // console.trace("increment");

    this._count++;
    this.isLoading.next(this.isBusy);
  }

  public desactivate() {
    // console.trace("decrement");
    this._count--;
    if (this._count < 0) this._count = 0;
    this.isLoading.next(this.isBusy);

  }
}
